import React from "react";
import "./UpsdmPage.css";
import BannerImage from "../Component/up_skill_development_mission_logo.jpeg.png"; // ✅ Replace with your actual image file name

const UpsdmPage = () => {
  return (
    <div className="upsdm-page">
      {/* 🔹 Banner Section */}
      <div className="upsdm-banner">
        <img src={BannerImage} alt="UPSDM Banner" className="banner-img" />
      
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 upsdm-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About UPSDM (Uttar Pradesh Skill Development Mission)
        </h2>

        <p>
          The Uttar Pradesh Skill Development Mission (UPSDM) is a flagship initiative launched by
          the Government of Uttar Pradesh to empower the youth with employable skills and create a
          skilled workforce across various industries. CPIT, as a recognized training partner of
          UPSDM, plays a key role in delivering high-quality vocational and technical training that
          helps students build a strong foundation for career growth and entrepreneurship.
        </p>

        <p>
          Under UPSDM, CPIT offers a wide range of short-term and long-term courses designed to meet
          industry demands. The programs include areas like Information Technology, Accounting,
          Retail, Automotive, and Communication Skills. Each course is carefully structured to
          provide a balance between theoretical knowledge and hands-on training, ensuring students
          are job-ready by the time they complete their training.
        </p>

        <p>
          One of the core strengths of the UPSDM program at CPIT is its focus on employability. The
          curriculum emphasizes practical learning, digital tools, and workplace readiness. Regular
          workshops, guest lectures, and internship opportunities help students gain real-world
          exposure and confidence to perform effectively in professional environments.
        </p>

        <p>
          After successful completion, students receive government-recognized certificates and
          placement support to help them secure meaningful employment or start their own ventures.
          The mission aims not only to reduce unemployment but also to uplift the socio-economic
          condition of the youth across Uttar Pradesh by making them self-reliant and future-ready.
        </p>
      </div>
    </div>
  );
};

export default UpsdmPage;
